import React, { useEffect, useState } from "react";
import { Box, Grid2, styled, Tab, Tabs, Typography, useTheme, Card } from "@mui/material";
import SubTabs from "components/SubTabs";
import subTabsItems from "components/subTabs-items";
import FinancialKPI from "./Financialprogress/FinancialKPI";
import TotalCostOfProject from "./Financialprogress/TotalCostOfProject";
import FundRequirement from "./Financialprogress/FundRequirement";
import CostPerformanceIndex from "./Financialprogress/CostPerformanceIndex";
import SCurveFinancialProgress from "./Financialprogress/SCurveFinancialProgress";
import InvoiceList from "./Financialprogress/InvoiceList";
import StatusOfInvoice from "./PaymentTracker/StatusOfInvoice";
import DistributionByDeduction from "./PaymentTracker/DistributionByDeductions";
import AdvancePayment from "./PaymentTracker/AdvancePayment";
import InvoiceStatusByValue from "./PaymentTracker/InvoiceStatusByValue";
import InvoiceListPaymentTracker from "./PaymentTracker/InvoiceListPaymentTracker";
import EarnedValueManagements from "./Financialprogress/EarnedValueManagement";
import AgingAnalysisPaymentTracker from "./PaymentTracker/AgingAnalysisPaymentTracker";
import { height } from "@mui/system";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

const Cost = () => {
    const theme = useTheme();
    const [earnedValueMan, setEarnedValueMan] = useState(null);
    const [cpi, setCpi] = useState(null);
    const [kpis, setKpis] = useState(null);
    const { hasPermission } = useCheckMenuPermission();

    const [value, setValue] = useState(null);

    useEffect(() => {
        const storedIndex = localStorage.getItem("costTabIndex");
        if (storedIndex !== null) {
            setValue(Number(storedIndex));
        } else {
            const firstPermittedTab = subTabsItems?.costSubTabs?.find(item =>
                hasPermission([item?.permissionKey])
            );
            if (firstPermittedTab != undefined) {
                localStorage.setItem("costTabIndex", firstPermittedTab.index ?? 0);
                setValue(firstPermittedTab?.index ?? 0)
            }
        }
    }, [hasPermission, subTabsItems]);

    const handleChange = (newIndex) => {
        setValue(newIndex);
        localStorage.setItem("costTabIndex", newIndex);
    };

    return (
        <>
            <SubTabs subTabs={subTabsItems?.costSubTabs} selectedTab={handleChange} selectedIndex={value} />
            <CustomTabPanel value={value} index={0}>
                <Grid2 size={12} sx={{ mt: "20px" }}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={1}
                    >
                        <Typography
                            sx={{
                                fontSize: '20px',
                                fontWeight: 500,
                                color: '#000',
                                mb: { xs: 0.5, md: 1 },
                                lineHeight: '100%',
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "left" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Status overview of all Projects
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#858EA0',
                                mb: { xs: 1, md: 1 },
                                lineHeight: '100%',
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "right" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Last Modified on 10th June 2025
                        </Typography>
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontWeight: 400,
                            color: '#182A4E80',
                            mb: "30px",
                            lineHeight: '100%',
                            letterSpacing: '-0.4px',
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
                    </Typography>
                </Grid2>
                <FinancialKPI kpisData={setKpis} />
                <Grid2 container spacing={1.25} sx={{ mt: "10px", }}>
                    <Grid2 size={{ xs: 12, md: 5 }}>
                        <Card sx={{ boxShadow: 'none', borderRadius: "7px", height: { xs: 'auto', md: '100%' }, border: "1px solid #2525252E" }}>
                            <SCurveFinancialProgress earnValueData={setEarnedValueMan} />
                        </Card>
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 7, lg: 7 }} sx={{}}>
                        <Grid2 container spacing={1.25}>
                            <Grid2 size={{ xs: 12, md: 6, lg: 6, }}>
                                <FundRequirement cpiData={setCpi} />
                            </Grid2>

                            <Grid2 size={{ xs: 12, md: 6, lg: 6, }}>
                                <CostPerformanceIndex cpiData={cpi} />
                            </Grid2>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 12, lg: 12 }} sx={{ mt: "11px" }}>
                            <TotalCostOfProject kpisData={kpis} />
                        </Grid2>
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={1.25} sx={{ mt: "10px", }}>
                    <Grid2 size={{ xs: 12, md: 5, lg: 5 }}>
                        <Card sx={{ boxShadow: 'none', borderRadius: "7px", height: { xs: 'auto', md: '450px' }, border: "1px solid #2525252E" }}>
                            <EarnedValueManagements earnValueData={earnedValueMan} />
                        </Card>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 7, lg: 7 }}>
                        <InvoiceList />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <Grid2 size={12} sx={{ mt: "20px" }}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={1}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                fontSize: '20px',
                                fontWeight: '500',
                                color: "#000000",
                                mb: { xs: 0.5, md: 1 },
                                lineHeight: "100%",
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "left" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Status overview of all Projects
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "#858EA0",
                                mb: { xs: 1, md: 1 },
                                lineHeight: "100%",
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "right" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Last Modified on 10th June 2025
                        </Typography>
                    </Box>
                    <Typography
                        variant="h5"
                        sx={{
                            fontSize: '18px',
                            fontWeight: '400',
                            mb: "30px",
                            color: '#182A4E80',
                            lineHeight: "100%",
                            letterSpacing: '-0.4px',
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
                    </Typography>
                </Grid2>

                <Grid2 container columnSpacing={1.25} rowSpacing={{ xs: 1.5, md: 0 }} sx={{ mt: "20px" }}> {/* <-- change here */}
                    <Grid2 size={{ xs: 12, md: 4, lg: 4 }} sx={{ height: { xs: "auto", md: "251px" } }}> {/* <-- change here */}
                        <AdvancePayment />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4, lg: 4 }} sx={{ height: { xs: "auto", md: "251px" } }}> {/* <-- change here */}
                        <DistributionByDeduction />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4, lg: 4 }} sx={{ height: { xs: "auto", md: "251px" } }}> {/* <-- change here */}
                        <StatusOfInvoice />
                    </Grid2>
                </Grid2>

                <Grid2 container columnSpacing={1} rowSpacing={{ xs: 1.5, md: 0 }} sx={{ mt: "10px" }}> {/* <-- change here */}
                    <Grid2 size={{ xs: 12, md: 7, lg: 7 }}>
                        <InvoiceStatusByValue />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 5, lg: 5 }}>
                        <AgingAnalysisPaymentTracker />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>

        </>
    );
};

export default Cost;